import type { Editor } from 'ckeditor5';

const getTextLoop = (element: ChildNode) => {
  const texts: string[] = [];
  const childNodes = [...element.childNodes];
  for (const node of childNodes) {
    if (node.nodeType === 3) {
      texts.push(node.textContent?.trim() ?? '');
    } else {
      texts.push(...getTextLoop(node));
    }
  }

  return texts;
};

const innerText = (element: HTMLDivElement) => getTextLoop(element).join(' ');

export const serialize = (editor: Editor) => {
  const html = editor.getData();

  const div = document.createElement('div');
  div.innerHTML = html;
  const text = innerText(div);

  return {
    html,
    text,
  };
};

// TODO: This is not plugin
